import { addDays, isBefore, subDays, differenceInDays } from "date-fns";
import { IShipment } from "../types";
import { startOfUTCDay } from "helpers/dates";

type AvailableDateOptions = {
    availableFrom?: Date;
    availableUntil?: Date;
    enforceAvailableUntil?: boolean;
    enforcePastShipStart?: boolean;
    minimumDeliveryWindow: number;
};

export const isAvailableDate = (
    { shipStart, shipEnd }: IShipment,
    {
        // product info
        availableFrom,
        availableUntil,
        // settings
        enforceAvailableUntil,
        enforcePastShipStart,
        minimumDeliveryWindow,
    }: AvailableDateOptions
) => {
    const today = startOfUTCDay(new Date());

    // with the enforcePastShipStart option, the shipment must start not later than today
    if (enforcePastShipStart && isBefore(shipStart, today)) {
        return false;
    }

    // when the product availableFrom is set,
    // it must not be earlier than Ship Start.
    if (availableFrom && isBefore(shipStart, availableFrom)) {
        return false;
    }

    // add 1 day to include range borders
    if (differenceInDays(shipEnd, shipStart) + 1 < minimumDeliveryWindow) {
        return false;
    }

    if (availableUntil && enforceAvailableUntil) {
        const earliestPossible = addDays(shipStart, minimumDeliveryWindow);

        // the product available until must not be earlier than ship start PLUS minimumDeliveryWindow gap.
        if (isBefore(availableUntil, earliestPossible)) {
            return false;
        }
        // with the enforceAvailableUntil option,
        // the shipment must not end after the product availability.
        if (isBefore(availableUntil, shipEnd)) {
            return false;
        }

        const latestPossible = subDays(shipEnd, minimumDeliveryWindow);
        if (isBefore(latestPossible, today)) {
            // today is within the window of last minimumDeliveryWindow shipment days
            return false;
        }
    }

    return true;
};
